import { SearchInvoiceActivities } from '@/app/features/DebtorPortal/InvoiceDetail/invoiceDetail.types';
import { ActivityStatus, ActivityType, TransactionType } from '@/app/features/DebtorPortal/InvoiceDetail/InvoiceNotesCard/InvoiceNotesCard.types';


export const useActivityHelpers = () => {
    const getActivityType = (activity: SearchInvoiceActivities): ActivityType => {
        if (activity.note) {
            return ActivityType.Note;
        }

        switch (activity.transactionType) {
            case TransactionType.Payment:
                return ActivityType.Payment;
            case TransactionType.Purchase:
                return ActivityType.Funded;
            case TransactionType.Submitted:
                return ActivityType.Submitted;
            case TransactionType.Adjustment:
                return ActivityType.Adjustment;
            case TransactionType.Chargeback:
                return ActivityType.Chargeback;
            case TransactionType.ShortPay:
                return ActivityType.ShortPay;
            case TransactionType.OverPay:
                return ActivityType.Payment;
            default:
                break;
        }

        switch (activity.status) {
            case ActivityStatus.Paid:
                return ActivityType.Payment;
            case ActivityStatus.Funded:
                return ActivityType.Funded;
            case ActivityStatus.Submitted:
                return ActivityType.Submitted;
            case ActivityStatus.Adjustment:
                return ActivityType.Adjustment;
            case ActivityStatus.Recoursed:
                return ActivityType.Chargeback;
            default:
                return ActivityType.Note;
        }
    };

    const getActivityLabel = (activity: SearchInvoiceActivities): string => {
        if (activity.note) {
            return 'Note';
        }

        if (activity.transactionType) {
            return activity.transactionType;
        }

        if (activity.status) {
            return activity.status;
        }

        return 'Activity';
    };

    return {
        getActivityType,
        getActivityLabel,
    };
};
